<template>
  <v-card v-if="ldg || items.length > 0" outlined class="mt-3">
    <v-card-title class="text-subtitle-2">
      <v-icon small class="mr-2">
        mdi-file-document-multiple
      </v-icon>

      Solicitudes de documentos
    </v-card-title>

    <v-card-text>
      <v-progress-linear v-if="ldg" indeterminate class="mb-3" />

      <v-expansion-panels v-else accordion flat>
        <v-expansion-panel v-for="(item, index) in items" :key="item.id">
          <v-expansion-panel-header>
            <v-row dense align="center">
              <v-col cols="12" md="1">
                <b>#{{ index + 1 }}</b>
              </v-col>

              <v-col cols="12" md="3">
                {{ item.requested_at || "-" }}
              </v-col>

              <v-col cols="12" md="4">
                {{ item.requested_by || "-" }}
              </v-col>

              <v-col cols="12" md="2">
                <v-chip x-small :color="getStatusColor(item)" dark>
                  {{ item.status }}
                </v-chip>
              </v-col>

              <v-col cols="12" md="2">
                {{ item.files.length }} archivo(s)
              </v-col>
            </v-row>
          </v-expansion-panel-header>

          <v-expansion-panel-content>
            <v-row dense>
              <v-col cols="12">
                <ViewData label="Petición" :value="item.observation" />
              </v-col>

              <v-col cols="12" md="6">
                <ViewData label="Solicitado por" :value="item.requested_by" />
              </v-col>

              <v-col cols="12" md="6">
                <ViewData
                  label="Fecha de solicitud"
                  :value="item.requested_at"
                />
              </v-col>

              <v-col v-if="item.completed_at" cols="12" md="6">
                <ViewData label="Cargado por" :value="item.completed_by" />
              </v-col>

              <v-col v-if="item.completed_at" cols="12" md="6">
                <ViewData label="Fecha de carga" :value="item.completed_at" />
              </v-col>

              <v-col v-if="item.files.length > 0" cols="12">
                <v-simple-table dense>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Descripción</th>
                        <th>Usuario</th>
                        <th>Fecha</th>
                        <th class="text-center">Archivo</th>
                      </tr>
                    </thead>

                    <tbody>
                      <tr
                        v-for="(file, file_index) in item.files"
                        :key="file.id"
                      >
                        <td>{{ file_index + 1 }}</td>
                        <td>{{ file.description || "-" }}</td>
                        <td>{{ file.uploaded_by || "-" }}</td>
                        <td>{{ file.uploaded_at || "-" }}</td>

                        <td class="text-center">
                          <BtnFilePreview
                            v-if="file.document"
                            :doc="file.document"
                            tooltip="Ver documento"
                            icon="mdi-file-eye"
                            :btn-props="{
                              color: 'primary',
                              icon: true,
                              small: true,
                            }"
                          />

                          <span v-else>-</span>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-col>

              <v-col v-else-if="item.upload_enabled && item.active" cols="12">
                <v-alert text dense type="warning">
                  La solicitud se encuentra pendiente de carga.
                </v-alert>
              </v-col>

              <v-col
                v-if="item.upload_enabled && item.active"
                cols="12"
                class="text-right"
              >
                <v-btn
                  small
                  color="error"
                  :loading="cancel_ldg"
                  :disabled="cancel_ldg"
                  @click.prevent="cancelRequest(item)"
                >
                  Cancelar solicitud

                  <v-icon right small>
                    mdi-close
                  </v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-card-text>
  </v-card>
</template>

<script>
import Axios from "axios";
import { URL_API, headersToken, msgAlert } from "../control";
import BtnFilePreview from "./BtnFilePreview.vue";
import ViewData from "./ViewData.vue";

export default {
  components: {
    BtnFilePreview,
    ViewData,
  },

  props: {
    rhaBillId: {
      type: [Number, String],
      default: 0,
    },
    rsServiceBillId: {
      type: [Number, String],
      default: 0,
    },
    refresh: {
      type: [Number, Boolean],
      default: 0,
    },
  },
  data() {
    return {
      login: this.$store.getters.getLogin,
      items: [],
      ldg: false,
      cancel_ldg: false,
    };
  },
  watch: {
    rhaBillId() {
      this.getItems();
    },

    rsServiceBillId() {
      this.getItems();
    },

    refresh() {
      this.getItems();
    },
  },
  methods: {
    getStatusColor(item) {
      if (!item.active) {
        return "error";
      }

      if (item.upload_enabled) {
        return "warning";
      }

      if (item.completed_at) {
        return "success";
      }

      return "grey";
    },

    getItems() {
      const rha_bill_id = parseInt(this.rhaBillId || 0);
      const rs_service_bill_id = parseInt(this.rsServiceBillId || 0);

      if (!rha_bill_id && !rs_service_bill_id) {
        this.items = [];

        return;
      }

      this.items = [];
      this.ldg = true;

      Axios.get(
        URL_API +
          "/bill_document_requests/history/" +
          rha_bill_id +
          "/" +
          rs_service_bill_id,
        headersToken(this.login.token),
      )
        .then((response) => {
          if (response.data.success) {
            this.items = response.data.data || [];
          } else {
            this.$swal.fire(msgAlert("error", response.data.message));
          }
        })
        .catch((error) => {
          console.log(error);

          const message =
            error.response && error.response.data && error.response.data.message
              ? error.response.data.message
              : "Error, contacte al equipo de soporte";

          this.$swal.fire(msgAlert("error", message));
        })
        .finally(() => {
          this.ldg = false;
        });
    },

    cancelRequest(item) {
      this.$swal
        .fire({
          title: "Cancelar solicitud",
          text: "La solicitud dejará de estar disponible en Portal Info.",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Sí, cancelar",
          cancelButtonText: "No",
        })
        .then((result) => {
          if (!result.isConfirmed) {
            return;
          }

          this.cancel_ldg = true;

          Axios.post(
            URL_API + "/bill_document_requests/cancel",
            {
              bill_document_request_id: item.id,
            },
            headersToken(this.login.token),
          )
            .then((response) => {
              this.$swal.fire(
                msgAlert(
                  response.data.success ? "success" : "error",
                  response.data.message,
                ),
              );

              if (response.data.success) {
                this.getItems();
                this.$emit("cancelled", response.data.data);
              }
            })
            .catch((error) => {
              console.log(error);

              const message =
                error.response &&
                error.response.data &&
                error.response.data.message
                  ? error.response.data.message
                  : "Error, contacte al equipo de soporte";

              this.$swal.fire(msgAlert("error", message));
            })
            .finally(() => {
              this.cancel_ldg = false;
            });
        });
    },
  },
  mounted() {
    this.getItems();
  },
};
</script>
